import DmsComponents from "./components"

const DMS = {
  ...DmsComponents
}
export default DMS;
